import { ViewModel,View, ViewModelMessage, ViewGenerator } from "binder"
import  { PreviewFormView } from "./previewForm-view"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { PreviewFormBuilderFormMessage } from "src/formBuilder/formBuilder/formBuilderWindow-viewModel";
import { ITemplateSelector } from "src/uicomponents/components/templateSelector";
import { Enum, IEnumTranslator, MediaSelector } from "uicomponents";
import { CompiledClass, GetEnumTranslationMessage, GetEnumTranslatorMessage } from "src/formBuilder/datamodel/classGenerator";
import { NodeExecutorRequestShowingPopupMessage } from "../formExecutor/formExecutor-viewModel";
import { BooleanType, ChartSeriesType, ClassProperty, ClassType, DataModel, DateType, FloatType, IPropertyTypeVisitor, IntegerType, KnownClassType, ListType, ServerSideDataLoaderType, StringType, VoidType } from "src/formBuilder/datamodel/structure";
import { distinct } from "src/common/utilities";
import { ServerConnection } from "src/server/serverConnection";
import moment from "moment";
import { ChartSeries } from "src/uicomponents/components/chart/chart-viewModel";

export class PreviewFormViewModel extends ViewModel implements ITemplateSelector,IPopup{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);

        this.templateSelector = this;
        this.templates = [];
        this._translators = new Map<string,Enum>();
        
    }
    GetDefaultView(): View <ViewModel> {
        return new PreviewFormView();
    }
    public getTypeId(): string {
        return "VM-684F642F-B3C9-4C61-95E9-7EAE9BD32B19"
    }

    private templates : Template[];
    private dataModel : DataModel;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    
    public set viewModel(v: ViewModel) { this._viewModel = v; } public get viewModel(): ViewModel { return this._viewModel;} private _viewModel: ViewModel;
    public set mainTemplateSelector(v: string) { this._mainTemplateSelector = v; } public get mainTemplateSelector(): string { return this._mainTemplateSelector;} private _mainTemplateSelector: string;
    public set templateSelector(v: ITemplateSelector) { this._templateSelector = v; } public get templateSelector(): ITemplateSelector { return this._templateSelector;} private _templateSelector: ITemplateSelector;
    
    public set popupTemplateSelector(v: string) { this._popupTemplateSelector = v; } public get popupTemplateSelector(): string { return this._popupTemplateSelector;} private _popupTemplateSelector: string;
    public set popupWidth(v: string) { this._popupWidth = v; } public get popupWidth(): string { return this._popupWidth;} private _popupWidth: string;
    public set popupHeight(v: string) { this._popupHeight = v; } public get popupHeight(): string { return this._popupHeight;} private _popupHeight: string;
    private _translators : Map<string,Enum>;
    private _selectedMediaTemplate:number;

    closePopup(result: any) {
    }
    private _msg :PreviewFormBuilderFormMessage; 
    preview(msg: PreviewFormBuilderFormMessage) {
        this._msg = msg;
        this._selectedMediaTemplate = this._msg.toShowTemplate.MediaType;
        this.load();
    }
    private async load(){
        let dataModel = new DataModel(this);
        dataModel.Parse(this._msg.dataModel);
        dataModel.generateClasses(this,false);
        this.dataModel = dataModel;
        let templates = this._msg.allTemplates.Templates;
        let translators = this.getAllRequiredTranslators(templates.map(t=>t.Html));
        await this.generateTranslators(translators);
        templates.forEach(t => {
            let template = new Template();
            template.name = t.Name;
            template.className = t.ClassName;
            let dataModelClass = this.dataModel.classes.filter(x=>x.name==t.ClassName)[0];
            let compiledClass = this.dataModel.GetCompliledClass(dataModelClass); 
            template.dataModelClass = compiledClass;
            template.isMain = t.IsMain;
            template.mediaType = t.MediaType ?? 0;
            let html : string = t.Html;
            html = html.replaceAll('data-b-comp-itemtemplateselector="','data-b-comp-importanthasselectorfunction="{Binding importanthasselectorfunction}"data-b-comp-itemtemplateselector="');
            template.html = html;
            template.htmlProto = ViewGenerator.CreatePrototype(html,'3169b9c8-8886-4885-8962-b197e3c391b4');
            this.templates.push(template);
        });
        let mainTemplates = this.templates.filter(x=>x.name==this._msg.toShowTemplate.Name);
        let mainTemplateName = this.filterTemplateByMediaType(mainTemplates,this._msg.toShowTemplate.MediaType);
        this.mainTemplateSelector = `return "${mainTemplateName.name}"`;
        let newInstance = this.generateNewInstance(mainTemplateName.dataModelClass);
        newInstance._Builder_TemplateSelector__ = this;
        this.viewModel = newInstance;
    }

    private generateNewInstance(cls:CompiledClass) : CompiledClass{
        return new testDataGenerator().generate(this,cls);
    }

    private async generateTranslators(requests:string[][]){
        let processAndEnum = distinct(requests.map(x=>x.join("!!"))).map(x=>x.split("!!"));
        try {
            this.isLoading = true;
            let translationInfo = await ServerConnection.callServer('/Complex/BpmsRawDataServices/GetTranslations',{
                EnumInfo:processAndEnum.map(x=>{return {
                    ProcessId:x[0],
                    EnumName:x[1]
                }})
            });
            translationInfo.Processes.forEach(process => {
                process.Enums.forEach(enu => {
                    let translatorparam = enu.Values.map(x=>{
                        let param = new translationValueAndStringMapping();
                        param.value = x.Value;
                        param.translation = x.Translation;
                        return param;
                    })
                    let translator = new GeneralTranslator(translatorparam);
                    this._translators.set(`${process.ProcessId.toLowerCase()}!!${enu.Name}`,translator);
                });
            });
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }
    getAllRequiredTranslators(t:string[]):string[][]{
        let result = [];
        t.forEach(x=>{
            let a = this.extractEnumTranslatorsRequests(x);
            result.push(...a);
            let b = this.extractEnumTranslationRequests(x);
            result.push(...b);
        });
        return result;
    }

    extractEnumTranslatorsRequests(html:string):string[][]{
        const upperLevelRegex = /{Binding\s*{([^}]*)},Converter:__GetEnumTranslator__[^}]*}/gm
        const innerRegex = /Static\s+([^,]+)/gm
        let matches = html.matchAll(upperLevelRegex);
        let result = [];
        for(const element of matches){
            let group = element[1];
            let innerMatches = group.matchAll(innerRegex);
            let singleResult = [];
            for(const innerElement of innerMatches){
                for(let i=1;i<innerElement.length;i++){
                    singleResult.push(innerElement[i]);
                }
            }
            result.push(singleResult);
        }
        return result;
    }
    extractEnumTranslationRequests(html:string):string[][]{
        const upperLevelRegex = /{Binding\s*{([^}]*)},Converter:__TranslateEnum__[^}]*}/gm
        const innerRegex = /Static\s+([^,]+)/gm
        let matches = html.matchAll(upperLevelRegex);
        let result = [];
        for(const element of matches){
            let group = element[1];
            let innerMatches = group.matchAll(innerRegex);
            let singleResult = [];
            for(const innerElement of innerMatches){
                for(let i=1;i<innerElement.length;i++){
                    singleResult.push(innerElement[i]);
                }
            }
            result.push(singleResult);
        }
        return result;
    }
    filterTemplateByMediaType(templates:Template[],mediaType):Template{
        try{
            let mediaTemplate : number = mediaType ?? this._selectedMediaTemplate;
            let result = MediaSelector.GetObjectByMediaTypeByStaticMediaType({
                default : ()=> <any>templates.filter(x=>x.mediaType==0).at(0),
                landscapeDefault : ()=> <any>templates.filter(x=>x.mediaType==1).at(0),
                portraitDefault : ()=> <any>templates.filter(x=>x.mediaType==2).at(0),
                portraitPhone : ()=> <any>templates.filter(x=>x.mediaType==3).at(0),
                landscapePhone : ()=> <any>templates.filter(x=>x.mediaType==4).at(0),
                portraitTablet : ()=> <any>templates.filter(x=>x.mediaType==5).at(0),
                landscapeTablet : ()=> <any>templates.filter(x=>x.mediaType==6).at(0),
                portraitLargeTablet : ()=> <any>templates.filter(x=>x.mediaType==7).at(0),
                landscapeLargeTablet : ()=> <any>templates.filter(x=>x.mediaType==8).at(0),
                desktop : ()=> <any>templates.filter(x=>x.mediaType==9).at(0),
            },mediaTemplate,true);
            return result;
        }catch{
            return null;
        }
    }
    getTemplate(vm: ViewModel, selector: string) {
        let functionProto = Function(`a=function(vm){${selector}};return a;`);
        let executableFunction = functionProto();
        let name = executableFunction(vm);
        let foundTemplatesNoMedia = this.templates.filter(x=>x.name==name);
        let found = this.filterTemplateByMediaType(foundTemplatesNoMedia,null);
        if(found==null)
            return null;
        let foundTemplate = found;
        return foundTemplate.htmlProto;    
    }
    handleMessage(msg:ViewModelMessage){
        if(msg instanceof NodeExecutorRequestShowingPopupMessage){
            return this.requestShowingPopup(msg.popup,false,{
                template : msg.template,
                width : msg.width,
                height : msg.height
            });
        }else if(msg instanceof GetEnumTranslatorMessage){
            let processId = msg.processId;
            let enumName = msg.enumName;
            return this._translators.get(`${processId.toLowerCase()}!!${enumName}`);
        }else if(msg instanceof GetEnumTranslationMessage){
            let processId = msg.processId;
            let enumName = msg.enumName;
            let translator = this._translators.get(`${processId.toLowerCase()}!!${enumName}`);
            return translator.translateValue(msg.value);
        }else{
            return super.handleMessage(msg);
        }
    }
}


class Template{
    public name:string;
    public className:string;
    public dataModelClass : CompiledClass;
    public isMain:boolean;
    public html:string;
    public htmlProto : any;
    public mediaType : number;
}

class translationValueAndStringMapping{
    value:number;
    translation : string;
}
class GeneralTranslator extends Enum implements IEnumTranslator{
    private _translationValues : Map<number,string>;
    constructor(values:translationValueAndStringMapping[]) {
        super();
        this._translationValues = new Map<number,string>();
        values.forEach(x=>this._translationValues.set(x.value,x.translation));
        
        this.values = values.map(x=>x.value);
        this.translator = this;
    }
    GetString(value: any) {
        return this._translationValues.has(value) ? this._translationValues.get(value) : "";
    }
    
}
class typedParameter{
    currentInstance : CompiledClass;
    depth : number;
    property:ClassProperty;
}
class testDataGenerator implements IPropertyTypeVisitor{
    private static strings = ['دولت','جمهوری','آذربایجان','و','نیروهای','ارامنه','در','قره‌باغ','درباره','بازگشایی','دو','مسیر','مورد','مناقشه','حمل','نقل','از','جمله','یک','کلیدی','موسوم','به','کریدور','لاچین','توافق','کرده‌اند.','نوشته','روزنامه','گاردین،','این','اقدام','که','ابتدا','توسط','آژانس','خبری','دولتی','"آرمن‌پرس"','ارمنستان','منتشر','باکو','تایید','شده،','نظر','می‌رسد،','دست','کم','تا','حدی','پاسخگوی','چندین','دهه‌','درخواست','برای','احیای','خطوط','بین','باشد.قره‌باغ','سطح','جهانی','عنوان','بخشی','رسمیت','شناخته','شده','است،','اما','زمان','جنگی','مصادف','با','فروپاشی','اتحاد','جماهیر','شوروی','دهه‌های','۸۰','۹۰','میلادی','بود،','جمعیتی','حدودا','۱۲۰','هزار','نفری','کنترل','می‌شود.جمهوری','نبردی','سال','۲۰۲۰','بخش‌های','بزرگی','را','تحت','خود','درآورد','۹','ماهه','گذشته','نیز','اعمال','محدودیت‌هایی','دسترسی','طریق','کشور','فشار','وارد','کرده','است.آرمن‌پرس','همچنین','قول','مقام‌های','گزارش','کرد:','آنها','تصمیم','دارند','اجازه','کالاهای','روسی','منطقه','شهر','"آسکران"','نزدیک','صادر','کنند.این','اشاره','منطقه‌ای','آن','جاده','وصل','می‌کند،','همزمان','توافقی','بازگرداندن','محموله‌های','بشردوستانه','حافظ','صلح','روسیه','کمیته','بین‌المللی','صلیب','سرخ','امتداد','حاصل','است.','دلیل','مشکلات','بشری','جدی','محاصره','منحرف','بود."حکمت','حاجیف"،','مشاور','سیاست‌گذاری','خارجی','ریاست','روز','شنبه','رویترز','گفته','بود','مسیرها','صورت','گرفته','است.دولت','پیشتر','ایروان','استفاده','قاچاق','سلاح','متهم','همین','پیشنهاد','رد','می‌کرد.این','روزی','انجام','رسیده','پارلمان','رئیس','جدید','انتخاب','کرد؛','اقدامی','غیرقانونی','دانست.اعلام','آمادگی','نظامی','چین','تحرک','ناوهای','آمریکابه','دنبال','تردد','تحریک','آمیز','آمریکا','کانادا','تنگه','تایوان،','مقام','ارشد','غروب','وقت','تهران','واکنش','نشان','داد.به','وبگاه','شبکه','«سی‌جی‌تی‌ان»،','«شی','یی»','سخنگوی','فرماندهی','شرق','گفت','یگان','عبور','کشتی‌های','ایالات','متحده','تایوان','داشت.','وی','هشدار','داد','ارتش','محافظت','قاطعانه','حاکمیت','امنیت','ملی','حفظ','حالت','آماده','باش','قرار','دارد.غروب','تهران،','نیروی','دریایی','اعلام','کرد','فروند','کشتی','کاناد','امروز','کردند؛','دومین','ماموریت','مشترک','ژوئن','حضور','سران','هر','نشست','گروه','«جی-۲۰»','هند','است.بر','اساس','گزارش،','ناوگان','هفتم','ناوموشک','انداز','«ی‌اس‌اس','رالف','جانسون»','«اچ‌ام‌سی‌اس','اوتاوا','کاناد»','آب‌های','مطابق','قوانین','کردند.','دهنده','تعهد','متحدان','اقیانوس‌','آرام','آزاد','باز','است.تایوان','شمار','می','رود','ادعا‌های','جدایی‌طلبانه','دارد؛','ادعا‌هایی','کشور‌های','جهان','سازمان','ملل','متحد','نمی‌شناسند.ارزیابی','اندیشکده','معتبر','آمریکایی','اخیرا','شد،','حکایت','دارد','رغم','کمک‌های','آمریکا،','دفاع','مقابل','ندارد.','ارزیابی','«رند»','باید','اقدامات','بیشتری','مقابله','تهاجم','دهد.','«آلکس','ولز-گرین»','امنیتی','سابق','«هریتیج»','«ویرانگر»','خواند.دیدار','هیات','بلندپایه','ایران','مقامات','باکووزارت','بیانیه‌ای','دیدار','مسلح','وزیر','خبر','محورهای','گفت‌وگوهای','طرفین','کرد.وبگاه','وزارت','انتشار','کرد،','«ذاکر','حسن‌اف»','(شنبه)','اسلامی','امیر','سرتیپ','«محمد','احدی»','استقبال','کرد.','شرکت','آذربایجان-ایران','سفر','است.طبق','باکو،','«اقدامات','بازسازی','مناطق','آزادشده','وضعیت','عملیاتی','مرزهای','آذربایجان-ارمنستان','اقتصادی','صحبت','کرد.»وزیر','گفت:','«برخی','تحریک‌آمیز','سوی','گسیل','یگان‌های','آذربایجان»،','محل','استقرار','موقت','صلح‌بانان','روسیه،','افزایش','یافته','است','تحریکات','«فورا','قاطعانه»','سرکوب','شدند.امیر','احدی','دیدار،','ضمن','تشکر','«مهمان‌نوازی»','طرف','مقابل،','سلام','سردار','سرلشکر','«محمدحسین','باقری»','رییس','ستادکل','ابلاغ','او','روابط','ریشه‌های','تاریخی','دارند،','بر','اهمیت','سفرهای','دوجانبه','منظور','گسترش','دوستانه','همسایگی','تاکید','کرد.طرفین','چشم‌انداز','توسعه','همکاری','میان','حوزه','نظامی،','مسائل','منطقه‌ای،','دیگر','مرتبط','منافع','تبادل‌نظر','کردند.در','پایان،','فعالیت‌های','پیش‌روی','آرزوی','موفقیت','ابراز','امیدواری','دیدارها','کمک','موثری','کند.','خواستار','سلامش','ستاد','کل','شد.'];
    public generate(parent:ViewModel,cls:CompiledClass):CompiledClass{
        return this.generateRecursive(parent,cls,3);
    }
    private getRandomDate(){
        let startOf2010 = 1264969800000;
        let twentyYears = 631152000000;
        let rnd = startOf2010 + Math.random()*twentyYears;
        return moment.utc(rnd);
    }

    private randomInt(min,max):number{
        return Math.trunc(this.randomFloat(min,max));
    }
    private randomFloat(min,max):number{
        let rnd = min+Math.random()*(max-min);
        return rnd;        
    }

    private generateRecursive(parent:ViewModel,cls:CompiledClass,depth:number):CompiledClass{
        let result = cls.__CreateNewInstance__(parent);
        
        let properties = cls.__DataModelClass__.GetProperties();
        properties.forEach(x=>{
            let parameter : typedParameter = {
                currentInstance : result,
                property : x,
                depth:depth-1
            };
            x.propertyType.Accept(this,parameter)
        })
        return result;
    }

    visitDateType(arg0: DateType, parameter: any) {
        let p = <typedParameter>parameter;
        p.currentInstance[p.property.name] = this.getRandomDate();
        return null;
    }
    visitServerSideDataLoaderType(arg0: ServerSideDataLoaderType, parameter: any) {
    }
    visitVoidType(arg0: VoidType, parameter: any) {
    }
    visitBooleanType(arg0: BooleanType, parameter: any) {
        let p = <typedParameter>parameter;
        p.currentInstance[p.property.name] = Math.random()>0.5 ? true :false;
        return null;   
    }
    visitIntegerType(arg0: IntegerType, parameter: any) {
        let p = <typedParameter>parameter;
        p.currentInstance[p.property.name] = this.randomInt(-100000000,100000000);
        return null;   
    }
    visitFloatType(arg0: FloatType, parameter: any) {
        let p = <typedParameter>parameter;
        p.currentInstance[p.property.name] = this.randomFloat(-100000000,100000000);
        return null;   
    }
    visitStringType(arg0: StringType, parameter: any) {
        let len = this.randomInt(1,8);
        let r = [];
        for(let i=0;i<len;i++){
            r.push(testDataGenerator.strings[this.randomInt(0,testDataGenerator.strings.length-1)]);
        }
        let p = <typedParameter>parameter;
        p.currentInstance[p.property.name] = r.join(' ');
        return ;
    }
    visitChartSeriesType(arg0: ChartSeriesType, parameter: any) {
        let p = <typedParameter>parameter;
        p.currentInstance[p.property.name] = new ChartSeries();
        return;

    }
    
    visitListType(arg0: ListType, parameter: any) {
        let p = <typedParameter>parameter;
        
        let listLen = this.randomInt(0,10);
        let lst = [];
        if(arg0.OfType instanceof KnownClassType){
            let clas = p.currentInstance.__DataModel__.GetCompliledClassByName(arg0.OfType.ForClass.name);

            for(let i=0;i<listLen;i++){
                lst.push(this.generateRecursive(p.currentInstance,clas,p.depth-1))
            }
        }
    }
    visitClassType(arg0: ClassType, parameter: any) {
    }
    visitKnownClassType(arg0: KnownClassType, parameter: any) {
        let p = <typedParameter>parameter;
        let clas = p.currentInstance.__DataModel__.GetCompliledClassByName(arg0.ForClass.name);
        let result = this.generateRecursive(p.currentInstance,clas,p.depth-1);
        p.currentInstance[p.property.name] = result;
    }
    
}